var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-bar"},_vm._l((_vm.data),function(item,index){return _c('research-report-chart-list-item',{key:index,attrs:{"showDel":false,"data":item},on:{"noDownloadPermissions":_vm.noDownloadPermissions,"uncollect":_vm.uncollect,"collection":_vm.collection,"download":_vm.download,"change":_vm.change}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }